var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePenLightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13209_5954)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#7A9FF8",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13209_5954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6172 7.04471C13.6067 6.97834 13.5002 6.38209 13.0682 5.94671C12.6343 5.52221 12.0358 5.41721 11.9691 5.40671C11.8802 5.39209 11.7894 5.41084 11.7133 5.45809C11.6867 5.47459 11.2956 5.71946 10.5234 6.37234C10.9206 6.51259 11.4339 6.75596 11.8502 7.16321C12.2679 7.57196 12.5177 8.07484 12.6609 8.46484C13.3059 7.71109 13.5486 7.32934 13.5647 7.30309C13.6127 7.22621 13.6314 7.13434 13.6172 7.04471Z",
    fill: "#7A9FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85658 6.9585C9.4542 7.3215 8.98583 7.7625 8.44958 8.295C6.17595 10.5525 5.5797 11.4551 5.55533 11.4922C5.5212 11.5447 5.50058 11.6051 5.4957 11.6674L5.37608 13.194C5.36783 13.3035 5.4072 13.4107 5.48483 13.4884C5.55533 13.5589 5.65095 13.5982 5.75033 13.5982C5.7597 13.5982 5.76945 13.5982 5.7792 13.5971L7.31708 13.4786C7.37895 13.4737 7.43858 13.4539 7.4907 13.4205C7.5282 13.3965 8.43683 12.8044 10.7101 10.5472C11.2583 10.0027 11.7106 9.52875 12.0807 9.12337C12.0241 8.88 11.8265 8.1855 11.3288 7.69912C10.8241 7.20525 10.0981 7.01175 9.85658 6.9585Z",
    fill: "#7A9FF8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13209_5954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13209_5954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePenLightBg);
export default __webpack_public_path__ + "static/media/blue-pen-light-bg.4919a000e6aeb7a130a0fdd6bb2c8b8c.svg";
export { ForwardRef as ReactComponent };